// extracted by mini-css-extract-plugin
export default {"authBtn":"Auth_authBtn__m7H1t","authBtnSection":"Auth_authBtnSection__1V+q9"};